declare global {
  interface Window {
    __APP_CONFIG__?: Record<string, string | undefined>;
  }
}

// Значення з window.__APP_CONFIG__ підставляються під час деплою (environments/config.<target>.js,
// підмінюється в build/config.js перед rsync) — один build, різний конфіг на ціль.
// process.env.REACT_APP_* лишається як fallback для локальної розробки (env-cmd + `npm start`),
// де build:runtime-конфігу немає.
const runtimeConfig: Record<string, string | undefined> =
  (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export const ENV = {
  NODE_ENV: runtimeConfig.REACT_APP_NODE_ENV ?? process.env.REACT_APP_NODE_ENV ?? '',
  CALLPHONE: runtimeConfig.REACT_APP_CALLPHONE ?? process.env.REACT_APP_CALLPHONE ?? '(067) 820-39-66',
  PUB_URL: runtimeConfig.REACT_APP_PUB_URL ?? process.env.REACT_APP_PUB_URL,
  API_HOST: runtimeConfig.REACT_APP_API_HOST ?? process.env.REACT_APP_API_HOST ?? '',
  WS_API_HOST: runtimeConfig.REACT_APP_WS_API_HOST ?? process.env.REACT_APP_WS_API_HOST ?? '',
  BLANKS_BUCKET_URL: runtimeConfig.REACT_APP_BLANKS_BUCKET_URL ?? process.env.REACT_APP_BLANKS_BUCKET_URL ?? '',
  POLICY_API_PROXY_API: runtimeConfig.REACT_APP_POLICY_API_PROXY_API ?? process.env.REACT_APP_POLICY_API_PROXY_API,
  POLICY_QRCODE_URL: runtimeConfig.REACT_APP_POLICY_QRCODE_URL ?? process.env.REACT_APP_POLICY_QRCODE_URL,
};
